import React from 'react';
import { Container } from 'react-bootstrap';
import HeaderTopbar from '../HeaderTopBar';
import { IHeaderProps } from '../../types/IHeader';

/**
 *
 * @param param
 * @returns
 */
const Header: React.FC<IHeaderProps> = ({
  brandAlt,
  brandSrc,
  brandWidth,
  brandHeight,
  brandClassName,
  brandURL,
  welcomeMessage,
  topBarHeading,
  isBrandVisible,
  isTopBarHeadingVisible,
  isButtonVisible,
  buttonArray,
  dropdownButtonArray,
}) => {
  return (
    <header data-testid="headerTestId" className="site-header">
      <Container fluid>
        <HeaderTopbar
          brandAlt={brandAlt}
          brandSrc={brandSrc}
          brandWidth={brandWidth}
          brandHeight={brandHeight}
          brandClassName={brandClassName}
          brandURL={brandURL}
          welcomeMessage={welcomeMessage}
          topBarHeading={topBarHeading}
          isBrandVisible={isBrandVisible}
          isTopBarHeadingVisible={isTopBarHeadingVisible}
          isButtonVisible={isButtonVisible}
          buttonArray={buttonArray}
          dropdownButtonArray={dropdownButtonArray}
        />
      </Container>
    </header>
  );
};

export default Header;
